import { createFileRoute } from '@tanstack/react-router';
import { CreateStaffForm } from '../../../../features/staff/components/CreateStaffForm';
import { FormPageLayout } from '../../../../components/layout/FormPageLayout';
import { usePageTitle } from '../../../../lib/hooks';

import { getSession } from '../../../../lib/session';
import { redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/admin/staff/new')({
  beforeLoad: ({ location }) => {
    const session = getSession();
    const isAllowed =
      session?.user.type === 'group_admin' ||
      session?.user.type === 'company_admin' ||
      session?.permissions.includes('user.create');
    if (!isAllowed) {
      throw redirect({ to: '/', search: { callbackUrl: location.href } });
    }
  },
  component: CreateStaffPage,
});

function CreateStaffPage() {
  usePageTitle('Add Staff Member');

  return (
    <FormPageLayout
      title="Add New Staff Member"
      subtitle="Provision a new employee profile, select their primary branch, and assign system permissions."
      backTo="/admin/staff"
      variant="card"
    >
      <CreateStaffForm />
    </FormPageLayout>
  );
}
